/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuRadioSelectList_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuCaratWeight_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuCaratWeight_searchBrowse = {|
  +appliedFilters: ?$ReadOnlyArray<?{|
    +name: ?string,
    +values: ?$ReadOnlyArray<?{|
      +urlLabel: ?string,
      +displayName: ?string,
    |}>,
  |}>,
  +$fragmentRefs: SbSharedRefineMenuRadioSelectList_searchBrowse$ref,
  +$refType: SbSharedRefineMenuCaratWeight_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuCaratWeight_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectList_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f8e066258633d9556d18f72f7da5133d';
module.exports = node;
